import Dropzone from 'react-dropzone'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface DropFile extends File {
  preview?: string
}

interface AcceptedFilesConfig {
  [key: string]: string[]
}

interface dropZoneProps {
  onDrop: (file: DropFile[]) => void
  title: string
  description: string
  acceptedFiles?: AcceptedFilesConfig
  multiple?: boolean
}

const defaultAcceptedExpenseFiles = {
  'image/*': [],
  'application/pdf': [],
  'application/xml': [],
  'text/xml': [],
}

const DropZoneBox = ({
  onDrop,
  title,
  description,
  acceptedFiles = defaultAcceptedExpenseFiles,
  multiple,
}: dropZoneProps) => {
  return (
    <Dropzone onDrop={onDrop} accept={acceptedFiles} multiple={multiple}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()} className={'DropZone_dropzone'}>
          <input {...getInputProps()} />
          <Box
            width="full"
            textAlign="center"
            padding="s12"
            borderRadius={{ all: 'abs006' }}
            border={{
              all: {
                width: 's2',
                style: 'dashed',
                color: 'grey400',
              },
            }}
          >
            <Box flexDirection="row" alignItems="center">
              <Box>
                <Icon.Large icon="file-upload" color="grey700" />
              </Box>
              <Box flexDirection="column" width="full">
                <Text.Normal weight="medium" size="200">
                  {title}
                </Text.Normal>
                <Text.Normal size="100">{description && description.toUpperCase()}</Text.Normal>
              </Box>
            </Box>
          </Box>
        </div>
      )}
    </Dropzone>
  )
}

export default DropZoneBox
